import { NavLink } from "react-router-dom";
import Modal from "../components/modal";
import { useState } from "react";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

const Header = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [animating, setAnimating] = useState(false);

  const handleOpen = () => {
    setModalOpen(true);
    setAnimating(true);
  };

  return (
    <>
      <header>
        <h1>M.k</h1>

        <ul>
          <li>
            <NavLink exact to="/" activeClassName="active">
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/projects" activeClassName="active">
              Projects
            </NavLink>
          </li>
          <li>
            <NavLink to="/skills" activeClassName="active">
              Skills
            </NavLink>
          </li>

          <li>
            <NavLink to="/about" activeClassName="active">
              About
            </NavLink>
          </li>

          <li>
            <NavLink to="/contact" activeClassName="active">
              Contact
            </NavLink>
          </li>
        </ul>
      </header>

      <div className="header-sm">
        <IconButton
          onClick={handleOpen}
          edge="start"
          sx={{
            color: "white",
            marginLeft: "25px",
          }}
          aria-label="menu"
        >
          <MenuIcon sx={{ fontSize: "40px" }} />
        </IconButton>

        <h1>M.k</h1>
      </div>

      {modalOpen && (
        <Modal
          setModalOpen={setModalOpen}
          setAnimating={setAnimating}
          animating={animating}
          isOpen={modalOpen}
        />
      )}
    </>
  );
};

export default Header;
